/*
  GO Motorsports global scripts.
  - Quantity steppers: <div class="quantity"> with [data-qty-minus], [data-qty-plus] and an input.
  - window.goToast(message): a short status message at the bottom of the screen (used by the rig builder).
  - Add-to-cart bridge: scripts the theme does not own (the rig builder) post to /cart/add.js themselves.
    When one of those adds succeeds, this fires 'cart:updated' and 'cart:added' so the header badge
    updates and the cart drawer opens, exactly as after a product-page add.
    The product form tags its own requests with the X-Go-Source header and fires the events itself.
*/
document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-qty-minus], [data-qty-plus]');
  if (!button) return;
  var input = button.closest('.quantity').querySelector('input');
  var step = Number(input.step) || 1;
  var min = input.min === '' ? 0 : Number(input.min);
  var max = input.max === '' ? Infinity : Number(input.max);
  var value = Number(input.value) || 0;
  value = button.hasAttribute('data-qty-plus') ? value + step : value - step;
  input.value = Math.min(max, Math.max(min, value));
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  var toast;
  window.goToast = function (message) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'toast';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    toast.innerHTML = '';
    var text = document.createElement('span');
    text.className = 'toast__text';
    text.textContent = message;
    toast.appendChild(text);
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-visible'); }, 5000);
  };

  if (!window.fetch) return;
  var nativeFetch = window.fetch;
  function isOwnRequest(init) {
    var headers = init && init.headers;
    if (!headers) return false;
    if (typeof headers.get === 'function') return !!headers.get('X-Go-Source');
    return !!headers['X-Go-Source'];
  }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    var promise = nativeFetch.apply(this, arguments);
    if (method !== 'POST' || !/\/cart\/add(\.js)?(\?|$)/.test(url) || isOwnRequest(init)) return promise;
    promise.then(function (response) {
      if (!response.ok) return;
      nativeFetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        document.dispatchEvent(new CustomEvent('cart:added', { detail: { cart: cart, items: [] } }));
      });
    }).catch(function () {});
    return promise;
  };
})();

/* Country / currency picker (snippets/localization-form.liquid): open/close the list, keyboard support,
   and submit the localization form with the chosen country. */
(function () {
  function close(root, focusButton) {
    var button = root.querySelector('[data-disclosure-toggle]');
    root.querySelector('[data-disclosure-list]').hidden = true;
    button.setAttribute('aria-expanded', 'false');
    if (focusButton) button.focus();
  }
  function open(root) {
    document.querySelectorAll('[data-disclosure]').forEach(function (other) { if (other !== root) close(other); });
    var list = root.querySelector('[data-disclosure-list]');
    list.hidden = false;
    root.classList.remove('disclosure--flip-end', 'disclosure--flip-start');
    // Line the list up with the side of the screen the button is on, and keep it on screen.
    var width = document.documentElement.clientWidth;
    var button = root.querySelector('[data-disclosure-toggle]').getBoundingClientRect();
    if (button.left + button.width / 2 > width / 2) root.classList.add('disclosure--flip-end');
    var box = list.getBoundingClientRect();
    if (box.left < 0) { root.classList.remove('disclosure--flip-end'); root.classList.add('disclosure--flip-start'); }
    else if (box.right > width) root.classList.add('disclosure--flip-end');
    root.querySelector('[data-disclosure-toggle]').setAttribute('aria-expanded', 'true');
    var current = list.querySelector('[aria-current="true"]') || list.querySelector('button');
    if (current) { current.focus(); current.scrollIntoView({ block: 'nearest' }); }
  }
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-disclosure-toggle]');
    if (toggle) {
      var root = toggle.closest('[data-disclosure]');
      if (toggle.getAttribute('aria-expanded') === 'true') close(root); else open(root);
      return;
    }
    var option = e.target.closest('[data-disclosure] .disclosure__option');
    if (option) {
      var form = option.closest('form');
      form.querySelector('[data-disclosure-input]').value = option.dataset.value;
      form.submit();
      return;
    }
    document.querySelectorAll('[data-disclosure]').forEach(function (root) {
      if (!root.contains(e.target)) close(root);
    });
  });
  document.addEventListener('keydown', function (e) {
    var root = e.target.closest && e.target.closest('[data-disclosure]');
    if (!root) return;
    var list = root.querySelector('[data-disclosure-list]');
    if (e.key === 'Escape' && !list.hidden) { e.preventDefault(); close(root, true); return; }
    if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && !list.hidden) {
      e.preventDefault();
      var options = Array.prototype.slice.call(list.querySelectorAll('.disclosure__option'));
      var i = options.indexOf(document.activeElement);
      var next = options[Math.min(options.length - 1, Math.max(0, i + (e.key === 'ArrowDown' ? 1 : -1)))];
      if (next) next.focus();
    }
  });
  document.addEventListener('focusout', function (e) {
    var root = e.target.closest && e.target.closest('[data-disclosure]');
    if (root && e.relatedTarget && !root.contains(e.relatedTarget)) close(root);
  });
})();

